<div [ngClass]="{'mat-card mat-elevation-z2 row no-gutters layer-row': !layer.aoi}">

    <div class="d-flex" cdkDragHandle>
        <div class="align-items-center">
            <mat-icon class="left-mat-icon"
                      *ngIf="hasEnabledChilds"
                      (click)="layer.cardExpansed = !layer.cardExpansed">
                {{layer.cardExpansed ? 'arrow_drop_down' : 'arrow_right'}}</mat-icon>
            <mat-icon class="left-mat-icon no-pointer"
                      *ngIf="!hasEnabledChilds"
            ></mat-icon>
        </div>
        <div class="layer-content d-flex align-items-center"
             [matTooltip]="!layer.enabled ? 'This layer does not have coverage in this area.': null"
             [matTooltipClass]="!layer.enabled ? 'custom-tooltip' : null">
            <mat-checkbox class="ms-1" [checked]="layer.visible" [value]="layer.id"
                          [disabled]="!layer.enabled" [ngClass]="{'disabled': !layer.enabled}"
                          (change)="changeVisibility($event)" [indeterminate]="someChecked">
                                                <span class="layer-name text-wrap"
                                                      [class.owner]="layer.owner">{{ layer.name }} </span>

            </mat-checkbox>


            <div *ngIf="!layer.aoi " class="mode-badge" [class.gray]="layer.layer.indexOf('gray') != -1">
                                                <span matTooltip="{{layer.description}}" matTooltipPosition="above"
                                                      matTooltipClass="custom-tooltip">2D</span>
            </div>
            <div *ngIf="!layer.aoi && layer.enableOblique" class="mode-badge second-mode-badge"
                 [class.gray]="layer.layer.indexOf('gray') != -1">
                                                <span matTooltip="{{layer.description}}" matTooltipPosition="above"
                                                      matTooltipClass="custom-tooltip">3D</span>
            </div>

        </div>
        <div class="tools-container">
            <button matIconButton [matMenuTriggerFor]="baseLayerMenu" *ngIf="showColorEnhancement || debug">
                <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu class="layer-menu" #baseLayerMenu="matMenu">

                <button [disabled]="!(layer.visible && layer.enabled) " mat-menu-item *ngIf="showColorEnhancement"
                        (click)="toggleLayerContrast(this.layer)">
                    <mat-icon class="switch-button"
                              [class.on]="layer.enableContrast">{{layer.enableContrast ? 'toggle_on' : 'toggle_off'}}</mat-icon>
                    <span>Disaster Auto Contrast</span>
                </button>
                <button mat-menu-item (click)="showLayerInfo(layer)" *ngIf="debug">
                    <span>Show layer info</span>
                </button>
            </mat-menu>
        </div>

    </div>

    <div *ngIf="layer.cardExpansed "
         class="child-layers" cdkDropList (cdkDropListDropped)="changeChildOrder($event)">
        <div *ngFor="let child of enabledChilds" cdkDrag>
            <app-layer-item (showInfoEvent)="showInfoEvent.emit($event)" [debug]="debug"
                            [zoomLevel]="zoomLevel" [layer]="child" (fitBBoxEvent)="fitToBbox($event)"
                            (toggleContrastEvent)="toggleContrastEvent.emit($event)"
                            (updateCollectionOrderEvent)="updateCollectionOrderEvent.emit($event)"
                            (changeVisibilityEvent)="changeVisibilityEvent.emit($event)"></app-layer-item>
        </div>

    </div>
</div>
